import { Component, PropTypes } from "react";

// TODO-MW-31: Centralize breakpoint constant
const BREAKPOINT_LG = 992;
const BREAKPOINT_MD = 768;

class HeroImage extends Component {
  render() {
    return (
      <div className="heroImage">
        <div className="heroImage__fullBleedWrapper">
          <picture>
            <source media={`(min-width: ${BREAKPOINT_LG}px)`}
                    srcSet={`${this.props.image.lg["1x"]} 1x, ${this.props.image.lg["2x"]} 2x`} />
            <source media={`(min-width: ${BREAKPOINT_MD}px)`}
                    srcSet={`${this.props.image.md["1x"]} 1x, ${this.props.image.md["2x"]} 2x`} />
            <img src={this.props.image.sm["1x"]}
                 srcSet={`${this.props.image.sm["2x"]} 2x`}
                 alt={this.props.image.altText}
                 className="heroImage__image" />
          </picture>
          { this.props.headline && <h1 className="heroImage__headline">{this.props.headline}</h1> }
        </div>
      </div>
    );
  }
}

HeroImage.propTypes = {
  image: React.PropTypes.shape({
    altText: React.PropTypes.string.isRequired,
    sm: React.PropTypes.shape({
      "1x": React.PropTypes.string,
      "2x": React.PropTypes.string,
    }).isRequired,
    md: React.PropTypes.shape({
      "1x": React.PropTypes.string,
      "2x": React.PropTypes.string,
    }).isRequired,
    lg: React.PropTypes.shape({
      "1x": React.PropTypes.string,
      "2x": React.PropTypes.string,
    }).isRequired,
  }).isRequired,
  headline: PropTypes.string,
};

export default HeroImage;
